<template>
  <v-card>
    <v-card-title class="align-center justify-center primary white--text mb-4">Historique</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="computedHistory"
        :items-per-page="5"
        item-key="sk"
        :show-expand="true"
        :single-expand="true"
        @item-expanded="copyObservation"
      >
        <template #expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row no-gutters class="my-6">
              <v-col cols="12">
                <v-textarea
                  v-model="newObservation"
                  outlined
                  no-resize
                  label="Observations"
                  style="width: 100%;"
                  hide-details
                />
              </v-col>
              <v-col cols="12" class="d-flex justify-end mt-4">
                <v-btn color="primary" class="white--text" :disabled="item.observation === newObservation" :loading="loadingObservation" @click="updateObservation(item)">
                  <span>Enregistrer</span>
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { format, fromUnixTime } from 'date-fns';
import { requests, EventBus } from '@/mixins/index';

export default {
  components: { },
  mixins: [requests],
  props: {
    contractHistory: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loadingObservation: false,
      headers: [
        { text: 'Date de modification du stock', value: 'date', width: '30%', align: 'center' },
        { text: 'Vieux stock', value: 'oldStock', width: '20%', align: 'center' },
        { text: 'Nouveau stock', value: 'newStock', width: '20%', align: 'center' },
        { text: 'Collaborateur', value: 'collaboratorUuid', width: '30%', align: 'center' }
      ],
      newObservation: null
    };
  },
  computed: {
    computedHistory () {
      return (this.$props.contractHistory || []).map(item => ({ ...item, date: format(fromUnixTime(item.timestamp), 'dd-MM-yyyy HH:mm') })).sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1));
    }
  },
  methods: {
    async updateObservation (history) {
      this.loadingObservation = true;
      const response = await this.changeContractHistoryObservation({ ...history, newObservation: this.newObservation });
      this.loadingObservation = false;

      const notification = {
        message: response.success ? 'Historique des stocks mis à jour avec succès.' : 'Erreur lors de la mise à jour de l\'historique des stocks.',
        type: response.success ? 'success' : 'danger',
        timeout: 10000
      };

      EventBus.$emit('show-notifications', [notification]);

      if (response.success) {
        const index = this.contractHistory.findIndex(h => h.sk === history.sk);
        if (index !== -1) {
          this.contractHistory[index].observation = this.newObservation;
        }
      }
    },
    copyObservation (event) {
      if (!event.value) {
        this.newObservation = null;
        return;
      }

      this.newObservation = event.item.observation;
    }
  }
};
</script>
